import React from "react";
import { PayInvoiceCheckoutForm } from "./components/StripePayInvoiceCheckoutform";
export const WalletStripeCardPayment = ({
  setRefreshCustomerData,
  setRefreshNotes,
  setShowAmountError,
  setRefreshPayInvoice,
  setShowPayInvoiceDialog,
  funcToCall,
  setFucToCallOnPay,
  onPaymentSuccess,
  amount,
  cpData,
  selectedInvoices,
}) => {
  return (
    <PayInvoiceCheckoutForm
      setRefreshCustomerData={setRefreshCustomerData}
      setShowAmountError={setShowAmountError}
      cpData={cpData}
      setRefreshNotes={setRefreshNotes}
      setRefreshPayInvoice={setRefreshPayInvoice}
      setShowPayInvoiceDialog={setShowPayInvoiceDialog}
      onPaymentSuccess={onPaymentSuccess}
      funcToCall={funcToCall}
      setFucToCallOnPay={setFucToCallOnPay}
      selectedInvoices={selectedInvoices}
      amount={amount}
    />
  );
};
